import { createContext, useContext } from 'react';
import { ModalProps } from '../../components';
import { Optional } from '../../utils/helpers';

export type ModelContextProps = Optional<ModalProps, 'onClose'>;

type ModalContextType = {
  modalProps: ModelContextProps;
  setModalProps: (props: ModelContextProps) => void;
};

const ModalContext = createContext<ModalContextType>(undefined!);

export const ModalContextProvider = ModalContext.Provider;

export const useModal = () => useContext(ModalContext);
